var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEssayWriter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M24 9h18M24 19h18M6 29h36M6 39h36M6 9.766a1 1 0 0 1 1.515-.857l7.056 4.233a1 1 0 0 1 0 1.716L7.515 19.09A1 1 0 0 1 6 18.234z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEssayWriter);
export default __webpack_public_path__ + "static/media/essayWriter.0e9d63a980d22307bbe6d39fae9191fb.svg";
export { ForwardRef as ReactComponent };